import { RadioGroupContext } from "./radio-group.context";
import type { RadioGroupRootProps } from "./types-radio-group";
import { useRadioGroup } from "./use-radio-group";
import { RadioGroupView } from "./view-radio-group";

export function RadioGroupRoot<T>({ children, ...options }: RadioGroupRootProps<T>) {
  const viewModel = useRadioGroup<T>(options);

  return (
    <RadioGroupContext.Provider value={viewModel}>
      <RadioGroupView
        orientation={viewModel.orientation}
        testId={viewModel.testId}
        className={viewModel.className}
        style={viewModel.style}
        rest={viewModel.rest}
        rootProps={viewModel.rootProps}
      >
        {children}
      </RadioGroupView>
    </RadioGroupContext.Provider>
  );
}
RadioGroupRoot.displayName = "RadioGroup.Root";
